import type { Project } from "@portfolio/shared/project";

export const projects: Project[] = [
 {
  id: "moongleapp",
  index: "01",

  title:
    "주문서 업무 자동화·AI 정보 탐색 웹 플랫폼",

  subtitle:
    "주문 자동화·AI 특가 탐색·뉴스 수집 서비스를 통합 제공",

  period:
    "2026.06 — 자체 서비스",

  contribution:
    "서비스 기획 · 반응형 프론트엔드 · Python 처리 프로그램 · 백엔드 API · DB · 배포",

  technologies: [
    "React",
    "TypeScript",
    "Python",
    "Vite",
    "SheetJS",
    "ExcelJS",
    "Local Database",
    "Cloudflare D1",
    "REST API",
    "Gemini API",
    "Responsive Web",
  ],

  accent: "blue",

  link:
    "https://apps.gguls.com/",

  mainImage: { type: "image", src: "/projects/apps01.webp" },
  subImages: [
    { type: "image", src: "/projects/apps01.webp" },
    { type: "image", src: "/projects/apps02.webp" },
    { type: "image", src: "/projects/apps03.webp" },
    { type: "image", src: "/projects/apps04.png" },
    { type: "image", src: "/projects/apps05.png" },
    { type: "image", src: "/projects/apps06.png" },
  ],

  overview:
    "스마트스토어 주문 데이터를 처리해 주문확인서를 생성하고, AI로 수집한 특가 정보를 정규화해 태그 기반 관계 그래프와 목록으로 제공하며, 여러 출처의 뉴스 콘텐츠를 수집·분류하도록 하나의 반응형 웹 플랫폼으로 기획·개발한 자체 서비스입니다. 모바일과 데스크톱 환경에 맞춰 각 서비스의 화면 구조와 탐색 방식을 최적화했습니다.",

  problem:
    "주문 자동화 영역에서는 반복적인 주문 데이터 정리와 문서 작성 과정을 줄이면서 사용자별 주문확인서 양식을 정확하게 반영해야 했습니다. 특가 탐색 영역에서는 판매처마다 형식이 다른 데이터를 정규화하고 상품·브랜드·카테고리 관계를 기반으로 연관 상품을 탐색할 수 있어야 했습니다. 뉴스 영역에서는 여러 출처의 콘텐츠를 일관된 기준으로 수집·분류해 주제별 탐색이 가능한 구조를 만들어야 했습니다. 또한 엑셀 처리 화면, 관계 그래프, 뉴스 목록처럼 정보 밀도가 높은 UI를 모바일의 작은 화면에서도 사용할 수 있도록 반응형 구조로 재구성해야 했습니다.",

  role: [
    "엑셀 분석·데이터 변환·문서 생성 기능 개발",
    "특가 수집·정규화·상품 관계 검색 및 그래프 시각화 구현",
    "콘텐츠 수집·분류·조회 기능 구현",
    "모바일·데스크톱 대응 공통 UI·REST API·데이터 모델 설계",
  ],

  solution:
    "주문 자동화 기능은 React와 TypeScript로 엑셀 업로드와 설정 화면을 구현하고, SheetJS와 웹에서 구동되는 Python 프로그램으로 주문 데이터를 분석·변환해 사용자 지정 양식의 주문확인서를 생성하도록 구성했습니다. 관련 설정과 데이터는 로컬 데이터베이스에 저장해 반복 작업에 재사용할 수 있도록 했습니다. 특가 탐색 기능은 Cloudflare Workers와 D1을 기반으로 특가 정보를 수집·정규화하고 상품·브랜드·카테고리·판매처·태그 관계를 연결해 연관 특가를 탐색하도록 구현했습니다. 뉴스 기능은 여러 출처의 콘텐츠를 수집하고 주제와 카테고리 기준으로 분류해 한곳에서 탐색할 수 있도록 구현했습니다. 모바일에서는 화면 너비에 따라 입력 영역과 목록 배치를 단일 열로 전환하고, 관계 그래프와 상세 정보 영역의 크기·간격·스크롤 방식을 조정해 작은 화면에서도 주요 기능을 사용할 수 있도록 반응형 UI를 적용했습니다.",

  metrics: [
    {
      value: "AUTOMATION",
      label:
        "주문 데이터 분석부터 주문확인서 생성까지 반복 업무 자동화",
    },
    {
      value: "DISCOVERY",
      label:
        "상품·브랜드·카테고리 관계를 활용한 연관 특가 탐색 구현",
    },
    {
      value: "RESPONSIVE",
      label:
        "엑셀·그래프·뉴스 화면을 모바일과 데스크톱에 최적화",
    },
  ],
},
  {
  id: "seecargo",
  index: "02",

  title:
    "화물 관제 배차 시스템",

  subtitle:
    "배차 확인부터 경로 안내·운행 위치 전송까지 연결한 React Native 기반 관제 앱",

  period:
    "2025.03 — 2025.06 · 에스엘솔루션",

  contribution:
    "React Native 화면 개발 · 지도 및 경로 연동 · FCM 알림 · 백그라운드 위치 수집",

  technologies: [
    "React Native",
    "TypeScript",
    "FCM",
    "Foreground Service",
    "Location API",
    "REST API",
  ],

  accent: "coral",
  mainImage: { type: "image", src: "/projects/seecargo.webp" },
  subImages: [
    { type: "image", src: "/projects/seecargo1.webp" },
    { type: "image", src: "/projects/seecargo2.webp" },
    { type: "image", src: "/projects/seecargo3.webp" },
  ],

  overview:
    "기사에게 배차 정보를 전달하고 배송지와 이동 경로를 지도에 표시하며, 운행 중 위치 정보를 관제 서버로 전송하도록 개발한 React Native 기반 화물 관제·배차 시스템입니다.",

  problem:
    "배차된 화물 정보를 모바일에서 빠르게 확인하고 신규 배차를 실시간으로 전달할 수 있어야 했습니다. 또한 배송지와 이동 경로를 지도에 명확하게 표시하고, 앱이 백그라운드 상태이거나 화면이 꺼진 상황에서도 운행 위치를 안정적으로 수집·전송할 수 있는 구조가 필요했습니다.",

  role: [
    "배차 목록·상세 화면 및 운행 상태 UI 개발",
    "배송지 마커와 이동 경로 지도 연동",
    "FCM 기반 신규 배차 및 상태 알림 구현",
    "Foreground Service 기반 백그라운드 위치 수집·전송",
  ],

  solution:
    "React Native와 TypeScript로 배차 목록·상세 화면과 운행 흐름을 구현하고, 지도 SDK를 연동해 배송지와 이동 경로를 시각화했습니다. 신규 배차와 주요 상태 변경은 FCM 알림으로 전달해 사용자가 즉시 확인할 수 있도록 구성했습니다. 운행 중 위치 정보는 Android Foreground Service를 기반으로 주기적으로 수집하고 REST API를 통해 관제 서버로 전송해 앱이 백그라운드 상태에서도 위치 추적이 유지되도록 구현했습니다.",

  metrics: [
    {
      value: "WORKFLOW",
      label:
        "배차 확인부터 경로 안내와 운행 처리까지 업무 흐름 통합",
    },
    {
      value: "NOTIFICATION",
      label:
        "신규 배차와 상태 변경을 FCM으로 실시간 전달",
    },
    {
      value: "TRACKING",
      label:
        "백그라운드에서도 운행 위치 수집·전송이 유지되는 구조 구현",
    },
  ],
},
{
  id: "pdr-android-sdk",
  index: "03",

  title:
    "센서 PDR 기반 융복합측위 Android App 및 SDK",

  subtitle:
    "Android 센서 데이터 수집·시각화 앱과 재사용 가능한 측위 SDK 개발",

  period:
    "2024.06 — 2024.12 · 티맵모빌리티",

  contribution:
    "Android 앱 개발 · 센서 데이터 처리 · SDK 모듈화 · C++ 라이브러리 연동",

  technologies: [
    "Kotlin",
    "Coroutine",
    "Retrofit2",
    "Android Sensor",
    "CSV",
    "C++",
    "JNI",
    "Android SDK",
  ],

  accent: "coral",

  mainImage: { type: "image", src: "/projects/sensor01.png" },
  subImages: [],
  overview:
    "Android 단말의 센서 데이터를 수집·저장하고 지도 위에 실시간으로 시각화하는 검증 앱과, 해당 기능을 다른 앱에서도 재사용할 수 있도록 구성한 Android SDK를 개발했습니다.",

  problem:
    "GPS 사용이 제한적인 실내 측위 환경을 검증하려면 가속도계와 자이로스코프 등 Android 센서 데이터를 안정적으로 수집해야 했습니다. 또한 수집 상태를 지도와 화면에서 실시간으로 확인하고, 분석용 데이터 저장과 서버 전송, C++ 기반 측위 라이브러리 연동까지 하나의 구조에서 지원해야 했습니다.",

  role: [
    "Android 센서 데이터 실시간 수집 및 처리",
    "지도 기반 센서·위치 데이터 시각화",
    "CSV 저장과 수집 데이터 뷰어 구현",
    "수집·저장·전송 기능 SDK화 및 JNI 연동",
  ],

  solution:
    "Kotlin과 Coroutine을 기반으로 Android 센서 데이터를 지속적으로 수집하고 상태 변화를 UI와 지도에 실시간으로 반영했습니다. 수집 데이터는 CSV 파일로 저장하고 앱 내부 뷰어에서 조회할 수 있도록 구성했으며, Retrofit2를 이용해 서버 전송 기능을 구현했습니다. 센서 수집·저장·조회·전송 기능은 재사용 가능한 Android SDK로 모듈화하고, JNI를 통해 C++ 기반 측위 라이브러리와 연동했습니다.",

  metrics: [
    {
      value: "REALTIME",
      label:
        "센서와 위치 데이터를 실시간으로 수집·시각화",
    },
    {
      value: "DATA PIPELINE",
      label:
        "수집 데이터의 저장·조회·서버 전송 흐름 구축",
    },
    {
      value: "REUSABILITY",
      label:
        "센서 처리 기능을 재사용 가능한 SDK로 모듈화하고 C++ 연동",
    },
  ],
},
{
  id: "tmap-ios-sdk",
  index: "04",

  title:
    "T MAP iOS SDK",

  subtitle:
    "기존 Objective-C 호환성을 유지하며 Swift 지원과 운영 안정성을 확장",

  period:
    "2020.03 — 2024.04 · SKT·티맵모빌리티",

  contribution:
    "Objective-C SDK 고도화 · Swift 버전 개발 · iOS 호환성 대응 · 배포",

  technologies: [
    "Objective-C",
    "Swift",
    "iOS",
    "Xcode",
    "T map SDK",
  ],

  accent: "blue",

  link:
    "https://tmapapi.tmapmobility.com/",
  mainImage: { type: "image", src: "/projects/tmap01.png" },
  subImages: [
    { type: "image", src: "/projects/tmap01.png" },
    { type: "image", src: "/projects/tmap02.png" },
    { type: "image", src: "/projects/tmap03.png" },
  ],

  overview:
    "운영 중인 Objective-C 기반 T map iOS SDK의 기능과 안정성을 개선하고, Swift 개발 환경을 지원하는 버전을 추가 개발하며 iOS 업데이트와 고객 요구사항에 지속적으로 대응한 프로젝트입니다.",

  problem:
    "다수의 기존 고객이 사용하는 Objective-C SDK의 공개 API와 동작 호환성을 유지하면서 기능과 안정성을 개선해야 했습니다. 동시에 Swift 개발 환경에서도 동일한 기능을 사용할 수 있도록 지원 범위를 확장하고, 지속적으로 변경되는 iOS 정책과 고객 요구사항에 대응해야 했습니다.",

  role: [
    "Objective-C SDK 기능 개선 및 오류 수정",
    "Swift 지원 버전 추가 개발",
    "iOS 버전별 호환성 검증과 대응",
    "고객 요구 기능 반영 및 SDK 배포",
  ],

  solution:
    "기존 Objective-C SDK의 공개 API와 동작 구조를 분석해 호환성을 유지하면서 오류와 기능을 개선했습니다. 동일한 주요 기능을 Swift 환경에서도 사용할 수 있도록 지원 버전을 개발하고, iOS 버전별 테스트를 통해 호환성 문제를 수정했습니다. 검증된 변경 사항은 배포 절차에 따라 운영 SDK에 지속적으로 반영했습니다.",

  metrics: [
    {
      value: "COMPATIBILITY",
      label:
        "기존 Objective-C 공개 API와 동작 호환성 유지",
    },
    {
      value: "EXPANSION",
      label:
        "Swift 개발 환경에서도 사용할 수 있도록 지원 범위 확장",
    },
    {
      value: "MAINTENANCE",
      label:
        "iOS 버전 변화와 고객 요구사항에 대응하는 운영 SDK 고도화",
    },
  ],
},
 {
  id: "europe-uvo-android",
  index: "05",

  title:
    "UVO Android App",

  subtitle:
    "유럽 지역별 언어와 차량 환경을 지원하는 커넥티드카 Android 앱 개발",

  period:
    "2019.02 — 2019.12 · 현대엠엔소프트",

  contribution:
    "Android 앱 개발 · 차량 상태 연동 · 지도 기능 · 실차 테스트 및 고도화",

  technologies: [
    "Android",
    "Java",
    "Map SDK",
    "Vehicle Integration",
    "Localization",
  ],

  accent: "blue",
  mainImage:{ type: "image", src: "/projects/uvo.webp" },
  subImages: [
    { type: "image", src: "/projects/uvo0.jpg" },
    { type: "image", src: "/projects/uvo1.jpeg" },
    { type: "image", src: "/projects/uvo2.jpeg" },
    { type: "image", src: "/projects/uvo3.webp" },
  ],

  overview:
    "유럽 시장용 UVO Android 앱에서 차량 상태 조회, 지도 및 위치 기반 기능, 다국어 화면을 개발하고 실제 차량과의 연동 테스트를 통해 기능을 검증·개선한 프로젝트입니다.",

  problem:
    "유럽 국가별 언어와 차량 사양 차이를 지원하면서 차량 상태와 위치 정보를 앱에 안정적으로 표시해야 했습니다. 또한 서버와 차량이 연결되는 실제 환경에서만 발생하는 연동 문제를 실차 테스트를 통해 확인하고 지속적으로 수정해야 했습니다.",

  role: [
    "유럽용 UVO Android 화면 및 기능 개발",
    "차량 상태 조회·표시 기능 연동",
    "지도 및 위치 기반 기능 구현",
    "실차 테스트 기반 오류 분석·수정",
  ],

  solution:
    "Java 기반 Android 앱에서 유럽 국가별 다국어 화면과 차량 상태 조회 기능을 구현하고, 지도와 위치 기반 기능을 연동했습니다. 차량과 서버에서 전달되는 상태 정보를 화면에 반영하도록 구성했으며, 실제 차량 환경에서 반복 테스트를 수행해 연동 오류와 예외 상황을 분석·수정했습니다. 테스트 결과를 바탕으로 기능 안정성과 사용 흐름을 지속적으로 개선했습니다.",

  metrics: [
    {
      value: "LOCALIZATION",
      label:
        "유럽 국가별 언어와 차량 사양을 반영한 앱 기능 구현",
    },
    {
      value: "INTEGRATION",
      label:
        "차량 상태와 서버 데이터를 앱 화면에 안정적으로 연동",
    },
    {
      value: "VALIDATION",
      label:
        "실차 테스트를 통해 연동 오류와 예외 상황 분석·개선",
    },
  ],
},
{
  id: "ggulmap",
  index: "06",

  title:
    "맛집 지도 서비스",

  subtitle:
    "탐색·추천·즐겨찾기와 사용자 참여형 정보 관리를 연결한 반응형 맛집 지도 서비스",

  period:
    "2026.06 — 개발 중 · 자체 서비스",

  contribution:
    "서비스 기획 · 반응형 프론트엔드 · 지도 클러스터링 · Workers API · D1 데이터 설계 · 배포",

  technologies: [
    "React",
    "TypeScript",
    "Vite",
    "Naver Maps API",
    "Cloudflare D1",
    "REST API",
    "Responsive Web",
  ],

  accent: "lime",

  link:
    "https://map.gguls.com/",
  mainImage: { type: "image", src: "/projects/ggulmap01.png" },
  subImages: [
    { type: "image", src: "/projects/ggulmap01.png" },
    { type: "image", src: "/projects/ggulmap02.png" },
    { type: "image", src: "/projects/ggulmap03.png" },
    { type: "image", src: "/projects/ggulmap04.png" },
    { type: "image", src: "/projects/ggulmap05.png" },
    { type: "image", src: "/projects/ggulmap06.png" },
  ],

  overview:
    "이름·주소·카테고리·태그 검색과 지도 필터로 맛집을 탐색하고, 좋아요 순위·조건별 랜덤 추천·즐겨찾기를 통해 새로운 장소를 발견할 수 있는 사용자 참여형 맛집 지도 서비스입니다. Google 로그인 사용자는 맛집을 직접 등록·수정하거나 삭제를 요청할 수 있으며, 모바일과 데스크톱 각각의 탐색 방식에 맞춘 반응형 UI와 PWA 설치 환경을 제공합니다.",

  problem:
    "전국 단위의 맛집 데이터를 지도에 한 번에 표시하면 마커 중첩과 렌더링 비용이 빠르게 증가하고, 작은 모바일 지도에서는 정보 밀도가 더 높아지는 문제가 있었습니다. 검색·필터·상세·추천처럼 서로 다른 탐색 흐름을 제한된 화면 안에서 자연스럽게 연결해야 했고, 여러 사용자가 맛집 정보를 함께 수정하는 과정에서는 충돌과 오래된 데이터 덮어쓰기를 방지할 필요가 있었습니다. 또한 이미지·카테고리·태그·영업시간·메뉴·사용자 반응을 일관되게 관리할 데이터 및 API 구조가 필요했습니다.",

  role: [
    "Naver Maps 기반 반응형 지도 탐색·검색·필터·상세 UI 개발",
    "줌·지도 범위 기반 서버 공간 그리드 및 클라이언트 클러스터링 구현",
    "Google 로그인·즐겨찾기·좋아요 순위·랜덤 추천 기능 개발",
    "REST API와 D1 데이터 모델, 편집 잠금·삭제 요청·관리자 기능 설계",
  ],

  solution:
    "React와 TypeScript, Naver Maps API로 지도 중심 화면을 구현하고 데스크톱은 사이드 패널, 모바일은 오버레이 중심으로 검색·필터·상세·추천 흐름을 재배치했습니다. 지도 범위와 줌 레벨에 맞는 데이터만 요청하고, 낮은 줌에서는 서버 공간 그리드 집계, 중간 줌에서는 클라이언트 클러스터링, 높은 줌에서는 개별 마커를 표시하는 단계별 전략으로 데이터가 많은 영역의 가독성과 렌더링 부하를 개선했습니다. TanStack Query로 지도 범위 캐시와 서버 상태를 관리하고, 이름·주소·카테고리·태그 검색, 현재 위치, 즐겨찾기 전용 지도, 좋아요 순위와 거리·음식 종류 기반 랜덤 추천을 연결했습니다. Workers REST API와 D1에는 맛집·이미지·태그·영업시간·메뉴·사용자 반응·수정 이력을 구조화했으며, 버전 검증과 편집 잠금·heartbeat로 동시 수정 충돌을 방지하고 삭제 요청과 관리자 검토 흐름까지 구성했습니다.",

  metrics: [
    {
      value: "HYBRID CLUSTER",
      label:
        "서버 공간 집계와 클라이언트 클러스터링을 결합한 단계별 지도 렌더링",
    },
    {
      value: "DISCOVERY",
      label:
        "검색·필터·좋아요 순위·랜덤 추천·즐겨찾기를 연결한 탐색 경험",
    },
    {
      value: "COLLABORATIVE DATA",
      label:
        "사용자 등록·수정과 편집 잠금·삭제 검토를 포함한 데이터 관리 흐름",
    },
  ],
},
];
